import { render } from "./Preloader.vue?vue&type=template&id=44a25fa6&scoped=true"
const script = {}

import "./Preloader.vue?vue&type=style&index=0&id=44a25fa6&scoped=true&lang=css"

import exportComponent from "C:\\Askar\\personalArea\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44a25fa6"]])

export default __exports__